import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { LayoutDashboard, Calendar, Package, Users } from 'lucide-react'

interface NavTab {
  icon: React.ReactNode
  label: string
  path: string
  colorClass: string
}

const AdminSubNav: React.FC = () => {
  const location = useLocation()

  const tabs: NavTab[] = [
    {
      icon: <LayoutDashboard size={18} />,
      label: 'Dashboard',
      path: '/admin',
      colorClass: 'border-red-500'
    },
    {
      icon: <Calendar size={18} />,
      label: 'Events',
      path: '/admin/events',
      colorClass: 'border-red-500'
    },
    {
      icon: <Package size={18} />,
      label: 'Orders',
      path: '/admin/orders',
      colorClass: 'border-red-500'
    },
    {
      icon: <Users size={18} />,
      label: 'Users',
      path: '/admin/users',
      colorClass: 'border-red-500'
    }
  ]

  const isActive = (path: string) => {
    if (path === '/admin') {
      return location.pathname === '/admin'
    }
    return location.pathname.startsWith(path)
  }

  return (
    <div className="bg-secret-bg-secondary border-b border-secret-border">
      <div className="flex justify-center space-x-1 overflow-x-auto">
        {tabs.map((tab) => {
          const active = isActive(tab.path)

          return (
            <Link
              key={tab.path}
              to={tab.path}
              className={`
                inline-flex items-center justify-center px-6 py-3 font-medium
                transition-colors whitespace-nowrap border-b-2
                ${active
                  ? `bg-primary text-white ${tab.colorClass}`
                  : 'bg-transparent text-secret-text-secondary hover:bg-secret-bg-tertiary border-transparent'
                }
              `}
            >
              <span className="mr-2">{tab.icon}</span>
              <span>{tab.label}</span>
            </Link>
          )
        })}
      </div>
    </div>
  )
}

export default AdminSubNav
